export default __webpack_public_path__ + "static/media/王建堯.6eaad642.jpg";